"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vertex_1 = require("../../base/vertex");
/**
 * Vertex with Name drawn on it.
 */
class NameVertex extends vertex_1.Vertex {
    constructor(name) {
        super();
        this.name = "";
        this.color = "";
        this.standarColor = "yellow";
        this.predefinedName = ['A', 'B', 'C', 'D',
            'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
            'U', 'V', 'W', 'X', 'Y', 'Z'];
        if (name == undefined || name == null) {
            this.name = this.predefinedName[NameVertex.ic++ % this.predefinedName.length];
        }
        else {
            this.name = name;
            if (this.predefinedName.includes(name)) {
                let newIC = (this.predefinedName.indexOf(name) + 1) % this.predefinedName.length;
                NameVertex.ic = newIC > NameVertex.ic ? newIC : NameVertex.ic;
            }
        }
    }
    static resetNames() {
        this.ic = 0;
    }
    setName(name) {
        this.name = name;
    }
    getName() {
        return this.name;
    }
    setColor(color) {
        this.color = color;
    }
    getColor() {
        return this.color;
    }
    resetColor() {
        this.color = this.standarColor;
    }
}
exports.NameVertex = NameVertex;
NameVertex.ic = 0;
